'use client'

import { useTranslation } from 'react-i18next'
import Link from 'next/link'
import { useSelectedLayoutSegment } from 'next/navigation'
import classNames from 'classnames'
import { Square3Stack3DIcon } from '@heroicons/react/24/outline'

type ExploreNavProps = {
  className?: string
}

const ExploreNav = ({ className }: ExploreNavProps) => {
  const { t } = useTranslation()
  const selectedSegment = useSelectedLayoutSegment()
  const actived = selectedSegment === 'ecs'

  return (
    <Link
      href='/ecs/instances'
      className={classNames(
        className,
        'group',
        actived && 'bg-white shadow-md',
        actived ? 'text-primary-600' : 'text-gray-500 hover:bg-gray-200',
      )}>
      {actived ? (
        <Square3Stack3DIcon className='mr-2 w-4 h-4' />
      ) : (
        <Square3Stack3DIcon className='mr-2 w-4 h-4' />
      )}
      {t('common.menus.ecs')}
    </Link>
  )
}

export default ExploreNav
